import { graphql, type ResultOf } from '@/gql/graphql';

export const OptimisticMessageMentionPersonFragment = graphql(/* GraphQL */ `
  fragment OptimisticMessageMentionPerson on person {
    __typename
    id
    name
  }
`);

type MessageMentionInsert = ReturnType<
  typeof graphql.scalar<'message_mention_insert_input'>
>;

export type ReadOptimisticMessageMentionPerson = (
  personId: string,
) => ResultOf<typeof OptimisticMessageMentionPersonFragment> | null;

export default function buildOptimisticMessageMentions(
  mentions: readonly MessageMentionInsert[],
  readPerson: ReadOptimisticMessageMentionPerson,
) {
  return mentions.flatMap((mention) => {
    if (!mention.id || !mention.person_id || !mention.fallback_label) {
      return [];
    }

    const person = readPerson(mention.person_id);

    return [
      {
        __typename: 'message_mention',
        id: mention.id,
        fallback_label: mention.fallback_label,
        person_id: mention.person_id,
        person,
      },
    ];
  });
}
